import { Component, OnInit, OnDestroy } from "@angular/core";
import { GradeService } from "../_services/grades.service";
import { DataService } from "src/app/dashboard/_services/data.service";
import { GlobalService } from "src/app/_services/global.service";
import { TranslateService } from "@ngx-translate/core";
import moment from 'moment';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { distinctUntilChanged, Subject, takeUntil, tap } from "rxjs";
import { TimeZoneService } from "src/app/_services/time-zone.service";
import { getGradeIssues } from "../_model/grade-issues";

// import { GlobalService } from 'src/app/_services/global.service';
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: "app-grades-classes",
  templateUrl: "./grades-classes.component.html",
  styleUrls: ["./grades-classes.component.scss"],
})
export class GradesClassesComponent implements OnInit, OnDestroy {
  grades = [];
  fullGrades = [];
  fullClasses = [];
  classes = [];
  /** the side index : every grade in one glance , next to the cards */
  gradesIndex: { id: any; name: string; classes: number; critical: boolean; warning: boolean }[] = [];
  activeGradeId = null;
  /** totals over the listed grades , shown on top of the index */
  gradesCount = 0;
  classesCount = 0;
  loading = true;
  currLang;
  compactView;
  rowsView = "compact";
  tableControls: any = { data: [] };
  dataArray;
  saveSortFlag:boolean = false;
  school_closing_time;
  formated_closing_time;
  starting_pickup_Time;
  current_time;
  today_name;
  showSortIcon:boolean = true;
  fieldsReadOnly: boolean = true;
  destroy$ = new Subject<void>(); 

  constructor(
    private gradesService: GradeService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private snackBar: SnackbarService,
    private timeZoneService:TimeZoneService
  ) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe((lng) => {
      //console.log('(c)grades-classes_(f)getLang_(L)53' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnDestroy(): void {
    this.dataService.setSearchText(null);
  }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe((lng) => {
      //console.log('(c)grades-classes_(f)getLang_(L)69' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getGrades();
    this.gradesService.getGradesReload().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      //console.log('(c)grades-classes_(f)getGradesReload_(L)75' , res);
      if (res) {
        this.loading = true;
        this.dataService.setSearchText(null);
        this.getGrades();
      }
    });

    this.dataService.getSearchText().pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
      if (res !== null) {
        this.loading = true;
        // wait some time to make loading appear
        setTimeout(() => {
          this.loading = false;
        }, 3000);
        if (res) {
          this.showSortIcon = false;
          this.saveSortFlag = false;
          this.fieldsReadOnly = true;
          // get all grades with the specified name
          this.grades = this.fullGrades.filter((grade) =>
            grade.name.toLowerCase().includes(res.toLowerCase())
          );
          // get all grades which contains specified class name
          this.fullGrades.map((grade) => {
            grade.school_classes.map((clazz) => {
              if (clazz.name.toLowerCase().includes(res.toLowerCase())) {
                this.grades = this.grades.filter(
                  (sGrade) => sGrade.id !== grade.id
                );
                this.grades.push(grade);
              }
            });
          });
        } else {
          this.showSortIcon = true;
          this.grades = this.fullGrades;
        }
        // this.getGrades();
        this.dataArray = this.grades;
        this.mapGrades();
        this.buildGradesIndex();
        this.translate.get("init").pipe(takeUntil(this.destroy$)).subscribe((res) => {
          this.setTableData();
        });
        this.translate.onLangChange.pipe(
          distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
          tap((res) => {
            this.setTableData();
          }),
          takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
        )
        .subscribe();
        // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((res) => {
        //   this.setTableData();
        // });
      }
    });

    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)grades-classes_(f)getRowsStyle_(L)126' , res);
      this.compactView = res;
      this.rowsView = res ? "compact" : "list";
      if(this.rowsView == "compact"){
        this.translate.get("init").pipe(takeUntil(this.destroy$)).subscribe((res) => {
        //console.log('(c)grades-classes_(f)translatInit_(L)131' , res);
        this.setTableData();
      });
      this.translate.onLangChange.pipe(
        distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
        tap((res) => {
          //console.log('(c)grades-classes_(f)translateOnChange_(L)135' , res);
          this.setTableData();
        }),
        takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
      )
      .subscribe();
      // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      //   this.setTableData();
      // });
      }
     
    });
  }

  addGrade() {
    $("#addGradeModal").modal("show");
  }
  initalizeNoResultFlag() {
    // fullGrades array represent the response that has all grades while grades can be filtered fullgrades for search filter ex..
    if (this.grades.length == 0 && this.fullGrades.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getGrades() {
    // this.loading = true;
    // getAllGrades() returns nothing until the grades cache is initialized,
    // fall back on the same subject so we simply wait for it.
    // The grades payload already carries each grade's flow/gates/supervisors
    // and each class's teachers, so no extra endpoint is needed here.
    const grades$ = this.dataService.getAllGrades() || this.dataService.setAllGrades;
    grades$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)grades-classes_(f)getAllGrades_(L)158' , res);
      this.grades = this.fullGrades = this.getDismissalTimesMappper(res);
      this.mapGrades();

      this.globalService.setAllGrades(this.fullGrades);
      this.classes = [];
      res.map((grade) => {
        this.classes = [...this.classes, ...grade.school_classes];
      });
      this.fullClasses = this.classes;
      this.buildGradesIndex();

      setTimeout(() => {
        this.loading = false;
      this.scroll();
      }, 1000);
    });
  }

  /** the side index , one row per rendered grade , flagged by what it is missing */
  buildGradesIndex() {
    this.gradesCount = this.grades.length;
    this.classesCount = this.grades.reduce(
      (total, grade) => total + (grade.school_classes?.length || 0),
      0
    );
    this.gradesIndex = this.grades.map((grade) => {
      const issues = getGradeIssues(grade);
      return {
        id: grade.id,
        name: grade.name,
        classes: grade.school_classes?.length || 0,
        critical: issues.hasCritical,
        warning: !issues.hasCritical && issues.hasWarning
      };
    });
  }

  /** side index -> the matching card */
  jumpToGrade(gradeId) {
    this.activeGradeId = gradeId;
    this.targetCardId = gradeId;
    this.scroll();
  }

  mapGrades(){
    this.dataArray = this.grades.map((grade) => ({
      name: grade.name,
      noOfClasses: grade.school_classes?.length,
      id: grade.id,
    }));
  }
  setTableData() {
    this.tableControls = {
      selection: false,
      paging: false,
      view: "list",
      sortingIndex:this.showSortIcon,
      columns: [
        {
          name: this.translate.instant("grades-classes.list-view.grade-name"),
          sort: false,
          type: "string",
          source: "name",
        },
        {
          name: this.translate.instant(
            "grades-classes.list-view.no-of-classes"
          ),
          sort: false,
          type: "string",
          source: "noOfClasses",
        },
        // {
        //   name:'id',
        //   sort: false,
        //   type: "string",
        //   source: "id",
        // },
        {
          name: this.translate.instant('table-view.edit'),
          type: "editIcon",
        },
     
      ],
      data: this.dataArray
    };
  }

  editListViewGrade(e, grade) {
    // reset starting pickup time with every edit.
    this.starting_pickup_Time = null;
    e.stopPropagation();
    this.current_time = moment(new Date()).format('HH:mm:ss');
    //get which day of week is today 
    this.today_name = moment(new Date()).format('dddd');
    // getting the school ending time by calling school info api
    this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => { 
      //console.log('(c)grades-classes_(f)getSchoolInfo_(L)289' , res);  
      let selectedSchool;
      selectedSchool = res.find(school=> school.selected == true);   
      this.school_closing_time = this.timeZoneService.convertToLocalTime(selectedSchool.school_closing_time , "HH:mm:ss" , "HH:mm:ss");
      if(this.school_closing_time !=null){
        this.formated_closing_time = this.timeZoneService.convertToLocalTime(selectedSchool.school_closing_time , "HH:mm:ss" , "hh:mm A" , true , this.currLang)
      }
      // getting the grade starting pickup time by calling grade api
      this.gradesService.getGrade(grade.id).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        //console.log('(c)grades-classes_(f)getGrade_(L)298' , res);  
        // get the day from dismissal_schedule that match todays date 
        if(res.dismissal_schedule.length > 0){
          let selectedDay = res.dismissal_schedule.find(day=> day.day_of_week == this.today_name)
          this.starting_pickup_Time = this.timeZoneService.convertToLocalTime(selectedDay.start_time , "HH:mm" , "HH:mm");
        }
        // check if school has an ending time to begin with
        if(this.school_closing_time != null){
       // checking dismissal started for each grade seperated 
          if(this.starting_pickup_Time < this.current_time  && this.current_time < this.school_closing_time){
            let err;
            this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
              //console.log('(c)grades-classes_(f)translateInit_(L)310' , res);  
              err = `${this.translate.instant('grades-classes.grade-card.dismissal-started')} ${this.formated_closing_time}`;
              err = err.replaceAll('"', '');
            });
            this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
              //console.log('(c)grades-classes_(f)translatOnChange_(L)315' , res);  
              err = `${this.translate.instant('grades-classes.grade-card.dismissal-started')} ${this.formated_closing_time}`;
              err = err.replaceAll('"', '');
            })    
            this.snackBar.setSnackBarMessage(err);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
          // dismissal period isn't on , user can open the modal and edit grade 
          else{
            this.gradesService.setGradeData(res);
            $("#addGradeModal").modal("show");
            }
        }
        else{
          this.gradesService.setGradeData(res);
          $("#addGradeModal").modal("show");
        } 
      })
    });
  }

  sortGrades(event){
    let currIndex;
    switch (event.target.order) {
      case 'asc':
        if(event.target.index != 0){
          currIndex = event.target.index;
          [this.dataArray[currIndex], this.dataArray[currIndex-1]] = [this.dataArray[currIndex-1], this.dataArray[currIndex]];
          this.setTableData();
        }
        break;

        case 'desc':
          if(event.target.index != (this.dataArray.length-1)){
            currIndex = event.target.index;
            [this.dataArray[currIndex], this.dataArray[currIndex+1]] = [this.dataArray[currIndex+1], this.dataArray[currIndex]];
            this.setTableData();
          }
          break;
      default:
        break;
    }
    
  }
  saveGradesSort(){
    this.loading = true;
    let body = this.dataArray.map((grade, index) => ({
      grade_id: grade.id,
      position:index,
    }));
    this.gradesService.updateGradesSorting(body).pipe(takeUntil(this.destroy$)).subscribe(res=>{
      //console.log('(c)grades-classes_(f)updateGradesSorting_(L)370' , res);  
    },err=>{
      // error in updating the grades 
            this.loading = false; 
            this.snackBar.setSnackBarMessage(err.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
    },()=>{
      this.dataService.updateGradesCache$().pipe(takeUntil(this.destroy$)).subscribe(res=>{
        this.saveSortFlag = false;
        this.fieldsReadOnly = true;
      },err=>{
        // error in updating grades cache  
            this.loading = false; 
            this.snackBar.setSnackBarMessage(err.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
      },()=>{
        this.loading = false
      })
    })
  }

  resetGradesSort(e){
    if(e == false){
      this.dataService.getAllGrades().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        //console.log('(c)grades-classes_(f)resetGradesSort_(L)404' , res);  
        this.dataArray = res.map((grade) => ({
          name: grade.name,
          noOfClasses: grade.school_classes?.length,
          id: grade.id,
        }));
        this.setTableData();
      });
    }
  }

  tableEventHandeler(event) {
    switch (event.action) {
      case "sortingIndex":
        this.saveSortFlag = event.target.toggleIndex;
        this.resetGradesSort(event.target.toggleIndex)
        break;
      case "iconClicked":
        this.editListViewGrade(event.e, event.target.data);
        break;
      case "sortingIndexRow":
        this.sortGrades(event)
        break;
      case "sorting":
        // this.toggleSorting(event.target.source);
        break;
      case "pagination":
        // this.paginationHandling(event.target);
        break;
    }
  }

  toggleSortingIndex(){
    this.saveSortFlag = !this.saveSortFlag;
    if(this.saveSortFlag){
      this.fieldsReadOnly = false;
    }
    else{
      this.fieldsReadOnly = true;
      this.resetGradesSort(false);
    }
  }
  dropGrade(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );

    // console.log(event.container.data);
  }

  targetCardId = null;
  scrollToGradePosition(event) { 
   this.targetCardId = event;
  }
  scroll(){
    if(this.rowsView != 'list' || this.targetCardId == null){
      return;
    }
    const element = document.getElementById(`card-${ this.targetCardId}`);
    if(element){
      // element.scrollIntoView();
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getDismissalTimesMappper(grades:any){
    return grades.map((grade: any) => ({
      ...grade,
      dismissal_schedule: grade.dismissal_schedule.map((dismissal: any) => ({
        ...dismissal,
        start_time: this.timeZoneService.convertToLocalTime(dismissal.start_time,"HH:mm" , "HH:mm"),
      })),
    }));
  }
}
